const Divider = ({borderColor = 'border-[#BFBFBF'}: {borderColor?: string}) => {
  return <div className={`w-full h-[0px] border ${borderColor}`} />;
};

export default Divider;
